import { render, staticRenderFns } from "./Authenticated.vue?vue&type=template&id=6fc7645e&"
import script from "./Authenticated.vue?vue&type=script&lang=js&"
export * from "./Authenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports